import { getApiBaseUrl, openUrl } from "@/utils/utils";
import { HTMLAttributeAnchorTarget } from "react";
import type { UUID } from "../../typings/global";
import { FinancialSector } from "../agent/enums";
import { PartnerSsoType } from "./enums";
import { PARTNER_ROUTE_PATHS } from "./paths";
import { MonlySsoProperties } from "./types";

export const redirectToMonlyAuthorizationCodeLogin = (token: string, monlySsoProps?: MonlySsoProperties) => {
  openUrl(
    `${monlySsoProps?.baseUrl}/fe/authexternal/userlogin` +
      "?response_type=code" +
      `&redirect_uri=${window.location.origin}${PARTNER_ROUTE_PATHS.ssoOAuthClient.to}` +
      `&client_id=${monlySsoProps?.clientId}` +
      `&state=${token}`,
    "_blank",
  );
};

export const redirectToMonlyAccessTokenLogin = (
  accessToken: string,
  target: HTMLAttributeAnchorTarget,
  monlySsoBaseUrl?: string,
) => {
  openUrl(`${monlySsoBaseUrl}/fe/authexternal/accesstokenlogin?access_token=${accessToken}`, target);
};

export const getFinancialSectorForSsoType = (ssoType: PartnerSsoType): undefined | FinancialSector => {
  switch (ssoType) {
    case PartnerSsoType.LUNA:
      return FinancialSector.CAPITAL_MARKET;
    case PartnerSsoType.EUCS:
      return FinancialSector.INSURANCES_OR_REINSURANCES;
    default:
      return undefined;
  }
};

// The endpoint ignores pictureId. It is there because replacing a picture keeps the URL otherwise the same, and browsers
// reuse an image already loaded from the same URL on the page, whatever the cache headers say.
export const resolvePartnerConfigBackgroundPictureUrl = (
  configId: UUID,
  pictureId: UUID,
  token?: string,
  accountId?: UUID,
) =>
  `${getApiBaseUrl()}/partner-configs/${configId}/background-picture?auth=${token}&accountId=${accountId}&pictureId=${pictureId}`;
